import axios from 'axios'
import { push } from 'react-router-redux'
import { EventTypes } from 'redux-segment'

import { clearCurrentUser } from '../utils/authUtils'
// import { sendNotification } from './NotificationActions'
// import * as MyProfileActions from './MyProfileActions'

export function validateToken() {
  return (dispatch, getState) => dispatch({
    type: 'VALIDATE_TOKEN',
    payload: axios('/auth/validate_token'),
  }).catch((error) => {
    clearCurrentUser()
    return Promise.reject(error)
  })
}

export function signIn(credentials) {
  return (dispatch, getState) => {
    dispatch({
      type: 'USER_SIGN_IN',
      payload: axios.post('/auth/sign_in', credentials)
    })
    .then((response) => {
      const user = response.action.payload.data.data
      if (user.has_dashboard) dispatch(push('/dashboard'))
        else dispatch(push('/sites'))
      if (window.mixpanel) {
        dispatch({
          type: 'ALIAS_EMAIL_USER',
          meta: {
            analytics: {
              eventType: EventTypes.alias,
              eventPayload: {
                userId: user.id,
                previousId: window.mixpanel.get_distinct_id(),
              }
            }
          }
        })
      }
    })
    .catch((error) => {
      clearCurrentUser()
      return Promise.reject(error)
    })
  }
}

export function resetPassword(email) {
  return (dispatch) => {
    dispatch({
      type: 'USER_RESET_PASSWORD',
      payload: axios.post('/auth/password', { email }),
    })
  }
}

export function signOut() {
  return (dispatch) => {
    const logout = () => {
      clearCurrentUser()
      dispatch(push('/login'))
    }
    dispatch({
      type: 'USER_SIGN_OUT',
      payload: axios.delete('/auth/sign_out')
    })
    .then(() => {
      logout()
    })
    .catch((error) => {
      logout()
    })
  }
}


export function setRedirectAfterLogin(path) {
  return {
    type: 'SET_REDIRECT_AFTER_LOGIN',
    payload: path,
  }
}

export function resetRedirectAfterLogin() {
  return {
    type: 'RESET_REDIRECT_AFTER_LOGIN',
  }
}

export function segmentIdentifyUser(user) {
  const eventPayload = {}
  if (user.email) {
    eventPayload['traits'] = {
      id: user['id'],
      email: user['email'],
      firstName: user['first_name'],
      lastName: user['surnname'],
      accessLevel: user['access_level'],
      companyName: user['company_name'],
      companyType: user['company_type'],
      signInCount: user['sign_in_count'],
      createdAt: user['created_at'],
      updatedAt: user['updated_at'],
    }
  }
  return (dispatch) => {
    dispatch({
      type: 'IDENTIFY_USER',
      meta: {
        analytics: {
          eventType: EventTypes.identify,
          eventPayload: eventPayload
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js